module.exports = __webpack_public_path__ + "static/media/act01.cacfdd14.mpeg";